<template>
    <v-app id="inspire">
        <v-container fill-height
                      style="background-color:whitesmoke"
                        fluid>
            <v-row align="center"
                    justify="center">
                <v-col cols="12"
                       sm="8"
                       md="4">

                    <v-row align-content="center" class="mb-7">
                        <div class="d-flex" align="center" style="margin:0 auto">
                            <img height="30" src="@/assets/favicon_asahi.png" class="mr-3" style="margin-top:2px"/>
                            <span class="font-weight-bold" style="font-size: 25px;">入出荷検品システム</span>
                        </div>
                    </v-row>

                    <v-alert type="error" v-if="err_message != ''">
                        {{ err_message }}
                    </v-alert>
                    <v-form method="post" action="/Login/CheckLogin">

                        <input type="hidden" name="ReturnUrl" v-model="return_url">
                        <v-card class="elevation-3 px-4 pb-8 pt-4">
                            <v-toolbar flat>
                                <v-toolbar-title style="margin:0 auto;font-size:25px;">ログイン</v-toolbar-title>
                                <!--<space>Ver - {{ app_version }}</space>-->
                            </v-toolbar>
                            <v-card-text>
                                <span style="font-size: 17px;">ログインID</span>
                                <v-text-field name="person_code"
                                              dense
                                              autofocus
                                              outlined
                                              prepend-inner-icon="mdi-account">

                                </v-text-field>
                                <span style="font-size: 17px;">パスワード</span>
                                <v-text-field name="password"
                                              type="password"
                                              dense
                                              outlined
                                              prepend-inner-icon="mdi-lock">

                                </v-text-field>
                                <!--<v-text-field label="パスワード" name="password"
                  prepend-icon="mdi-lock"
                  type="password">

    </v-text-field>-->
                            </v-card-text>
                            <v-card-actions class="px-4">
                                <v-btn color="primary"
                                       block
                                       type="submit">
                                    LOGIN
                                </v-btn>

                            </v-card-actions>
                        </v-card>
                    </v-form>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>

    import Vue from 'vue';
    import MyCommon from '../../components/MyCommon.vue';
    Vue.mixin(MyCommon);

    export default {
        mounted: function () {
            this.$nextTick(function () {
                this.setPrimary(this.$vuetify.theme.themes.light.centersyukko);
                this.return_url = new URL(location.href).searchParams.get('ReturnUrl');
            });
        },
        data: () => ({
            return_url: '',
            app_version: g_version,
            err_message: g_errmessage
        })
    };
</script>
